import { Component, Vue } from 'vue-property-decorator';
// @ is an alias to /src

@Component
export default class SidenaviSearcharea extends Vue {
  private　name = 'sidenavisearcharea';
}
